import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=7a8833ed&scoped=true&"
import script from "./PersonInfo.vue?vue&type=script&lang=js&"
export * from "./PersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=7a8833ed&lang=css&scoped=true&"
import style1 from "./PersonInfo.vue?vue&type=style&index=1&id=7a8833ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8833ed",
  null
  
)

export default component.exports